<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
    >
      <el-form-item label="角色名称" prop="roleName">
        <el-input
          v-model="queryParams.roleName"
          placeholder="请输入角色名称"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select
          v-model="queryParams.isValid"
          placeholder="角色状态"
          clearable
          style="width: 240px"
        >
          <el-option
            v-for="dict in statusOptions"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="queryParams.createDate"
          style="width: 240px"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增</el-button
        >
      </el-col>
      <right-toolbar
        :showSearch.sync="showSearch"
        @queryTable="getList"
      ></right-toolbar>
    </el-row>

    <el-table
      v-loading="loading"
      :data="roleList"
      height="calc(100vh - 330px)"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="角色编号" prop="id" align="center" width="120" />
      <el-table-column
        label="角色名称"
        prop="roleName"
        align="center"
        :show-overflow-tooltip="true"
      />
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isValid"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createdTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
        <template slot-scope="scope">
          <span>{{ scope.row.createDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope" v-if="scope.row.roleId !== 1">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <!-- <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            >删除</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      @pagination="getList"
    />

    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body       :close-on-click-modal="false"
      :close-on-press-escape="false"
>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="form.roleName" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item label="状态" prop="isValid">
          <el-radio-group v-model="form.isValid">
            <el-radio
              v-for="dict in statusOptions"
              :key="dict.value"
              :label="dict.value"
              >{{ dict.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="form.roleRemark"
            type="textarea"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTRoleSelectByPage,
  postTRoleInsertAdd,
  postTRoleUpdate,
  postTRoleDelete,
  getTRoleIDdep,
  postTRoleUpdateStatus,
} from "@/api/plat/PosMana";
export default {
  name: "Role",
  data() {
    return {
      statusOptions: [
        { value: 1, label: "启用" },
        { value: 2, label: "停用" },
      ],
      loading: false,
      ids: [],
      single: true,
      multiple: true,
      showSearch: true,
      total: 0,
      roleList: [],
      title: "",
      open: false,
      queryParams: {
        limit: 10,
        page: 1,
        orderBy: "",
        createDate: undefined,
        id: undefined,
        isValid: undefined,
        roleName: undefined,
        roleRemark: undefined,
        updateDate: undefined,
      },
      form: {},
      rules: {
        roleName: [
          { required: true, message: "角色名称不能为空", trigger: "blur" },
        ],
        isValid: [{ required: true, message: "状态不能为空", trigger: "blur" }],
      },
    };
  },
  async created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      let { data, count } = await getTRoleSelectByPage(this.queryParams);
      this.roleList = data;
      this.total = count;
      this.loading = false;
    },
    handleStatusChange(row) {
      let text = row.isValid === 1 ? "启用" : "停用";
      this.$confirm
        (`确认要"${text}""${row.roleName}"角色吗？`)
        .then(async () => {
          let reps = await postTRoleUpdateStatus({
            id: row.id,
            isValid: row.isValid,
          });
          if (reps.code == 200) {
            this.$message.success(text + "成功");
          } else {
            row.isValid = row.isValid === 0 ? 1 : 0;
          }
        })
        .catch(() => {
          row.isValid = row.isValid === 0 ? 1 : 0;
        });
    },
    cancel() {
      this.open = false;
      this.reset();
    },
    reset() {
      this.form = {
        id: undefined,
        isValid: 1,
        roleName: "",
        roleRemark: "",
      };
    },
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery() {
      // 只清筛选项，保留分页参数（原来整个 queryParams 被清空，连 limit/page 一起丢了：
      // 控件显示 20 条/页、请求却不带 limit）
      const limit = this.queryParams.limit;
      this.queryParams = { limit, page: 1 };
      this.handleQuery();
    },
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.roleId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加角色";
    },
    async handleUpdate(row) {
      this.reset();
      this.form = row;
      this.open = true;
      this.title = "修改角色";
    },
    submitForm() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          if (this.form.id != undefined) {
            await postTRoleUpdate(this.form);
            this.$message.success("修改成功");
          } else {
            await postTRoleInsertAdd(this.form);
            this.$message.success("新增成功");
          }
          this.open = false;
          this.getList();
        }
      });
    },
    handleDelete(row) {
      this.$confirm
        (`是否确认删除角色编号为"${row.roleName}"的数据项？`)
        .then(() => postTRoleDelete([row.id]))
        .then(() => {
          this.getList();
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },
  },
};
</script>
